export default __webpack_public_path__ + "static/media/camera.a9403a06.svg";